// src/App.tsx

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/HomePage/HomePage";
import BasicPage from "./pages/TaxQuotePage/BasicPage";
import InvestmentPage from "./pages/TaxQuotePage/InvestmentPage";
import ForeignIncomeAssetsPage from "./pages/TaxQuotePage/ForeignIncomePage";
import OtherMiscPage from "./pages/TaxQuotePage/OtherMiscPage";
import SummaryPage from "./pages/TaxQuotePage/SummaryPage";
import AppointmentPage from "./pages/AppointmentPage/AppointmentPage";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage/ContactUsPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import CustomerManagement from "./pages/CustomerManagement/CustomerManagement";
import AddCustomer from "./pages/CustomerManagement/AddCustomer";
import AddInvoice from "./pages/CustomerManagement/AddInvoice";
import EditItem from "./pages/CustomerManagement/EditItem";
import { QuoteProvider } from "./context/QuoteContext";
import AnnualTaxReturnReviewPage from "./pages/AppointmentPage/AnnualTaxReturnReviewPage";
import PersonalTaxPlanningPage from "./pages/AppointmentPage/PersonalTaxPlanningPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import DocsPage from "./pages/DocsPage/DocsPage";
import NewClientConsultingPage from "./pages/AppointmentPage/NewClientConsultingPage";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <QuoteProvider>
        <Router>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/quote/basic" element={<BasicPage />} />
              <Route path="/quote/investment" element={<InvestmentPage />} />
              <Route
                path="/quote/foreign_income_assets"
                element={<ForeignIncomeAssetsPage />}
              />
              <Route path="/quote/other_misc" element={<OtherMiscPage />} />
              <Route path="/quote/summary" element={<SummaryPage />} />
              <Route path="/appointment" element={<AppointmentPage />} />
              <Route
                path="/appointment/annual-tax-return-review"
                element={<AnnualTaxReturnReviewPage />}
              />
              <Route
                path="/appointment/personal-tax-planning"
                element={<PersonalTaxPlanningPage />}
              />
              <Route
                path="/appointment/new-client-consulting"
                element={<NewClientConsultingPage />}
              />
              <Route path="/about" element={<AboutUsPage />} />
              <Route path="/contact" element={<ContactUsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/docs" element={<Navigate to="/docs/step0" />} />
              <Route path="/docs/:docId" element={<DocsPage />} />

              {/* 使用 ProtectedRoute 保护需要认证的路由 */}
              <Route
                path="/customer_management"
                element={
                  <ProtectedRoute>
                    <CustomerManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer_management/add"
                element={
                  <ProtectedRoute>
                    <AddCustomer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer_management/add-invoice"
                element={<AddInvoice />}
              />
              <Route
                path="/customer_management/edit/:type/:id"
                element={<EditItem />}
              />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </QuoteProvider>
    </AuthProvider>
  );
};

export default App;
